import styled from 'styled-components';

export const Base = styled.div`
	position: relative;
	display: flex;
	align-items: center;

	&::before {
		content: '';
		position: absolute;
		top: 100%;
		left: 0;
		width: 100%;
		height: 4px;
		z-index: 999;
	}
`;

export const Button = styled.button`
	background: none;
	border: none;
	padding: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 34px;
	height: 40px;
	border-radius: 4px;
	outline: none;

	&:hover {
		background-color: ${({ theme }) => theme.gray[100]};
	}
`;

export const Dropdown = styled.div<{ $leftOffset?: number; $openLeft?: boolean }>`
	position: absolute;
	top: 100%;
	left: ${({ $leftOffset }) => $leftOffset ?? 0}px;
	margin-top: 4px;
	background: ${({ theme }) => theme.gray[0]};
	border-radius: 8px;
	padding: 4px;
	min-width: 200px;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
	border: 1px solid ${({ theme }) => theme.gray[200]};
	z-index: 1000;
`;

export const Submenu = styled.div<{ $openLeft?: boolean }>`
	position: absolute;
	${({ $openLeft }) =>
		$openLeft ? 'right: calc(100% + 4px);' : 'left: calc(100% + 4px);'}
	top: -4px;
	min-width: 180px;
	max-height: 300px;
	overflow-y: auto;
	background: ${({ theme }) => theme.gray[0]};
	border-radius: 8px;
	padding: 4px;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
	border: 1px solid ${({ theme }) => theme.gray[200]};
	opacity: 0;
	visibility: hidden;
	transform: ${({ $openLeft }) => ($openLeft ? 'translateX(8px)' : 'translateX(-8px)')};
	transition: all 0.15s ease-out;
	z-index: 1001;
`;

export const DropdownItemWrapper = styled.div`
	position: relative;

	&:hover ${Submenu} {
		opacity: 1;
		visibility: visible;
		transform: translateX(0);
	}
`;

export const DropdownItem = styled.div<{ $hasSubmenu?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 8px 12px;
	border-radius: 6px;
	color: ${({ theme }) => theme.gray[1000]};
	font-family: 'Inter', sans-serif;
	font-size: 14px;
	font-weight: 500;
	transition: all 0.1s ease;
	outline: none;

	&:hover {
		background: ${({ theme }) => theme.gray[100]};
	}
`;

export const DropdownItemContent = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`;

export const SubmenuItem = styled.div`
	display: flex;
	align-items: center;
	padding: 8px 12px;
	border-radius: 6px;
	color: ${({ theme }) => theme.gray[1000]};
	font-family: 'Inter', sans-serif;
	font-size: 14px;
	font-weight: 400;
	transition: all 0.1s ease;
	outline: none;
	white-space: nowrap;

	&:hover {
		background: ${({ theme }) => theme.gray[100]};
	}
`;
